if (!customElements.get('polat-showroom-videos')) {
  customElements.define('polat-showroom-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.polat-video-track');
      const buttons = [...this.querySelectorAll('[data-video-step]')];
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.videoStep) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('figure');
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left: distance * Number(button.dataset.videoStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      const tourLink = this.closest('section')?.querySelector('[data-showroom-tour]');
      tourLink?.addEventListener('click', event => {
        const card = document.getElementById(tourLink.hash.slice(1));
        const video = card?.querySelector('video');
        if (!video || !this.contains(card)) return;
        event.preventDefault();
        card.scrollIntoView({block: 'center', inline: 'end', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        video.setAttribute('tabindex', '0');
        video.focus({preventScroll:true});
        video.play().catch(() => { /* Native controls remain available if playback is blocked. */ });
      });
      this.querySelectorAll('video').forEach(video => video.addEventListener('play', () => this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
  });
}
